export default __webpack_public_path__ + "static/media/redbus.1fc37100.png";